var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"timer"},[_vm._v(" 00:"+_vm._s(_vm._f("formatTime")(_vm.currentTime))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }